/* SHREDDERS – le chalet (collection 01)
   Une vraie photo de chalet (générée une fois), et par-dessus :
   - les chandails accrochés aux patères (rendus 3D, une image par couleur), cliquables ;
   - le feu qui danse dans le poêle, sa lueur sur le plancher, des étincelles ;
   - la neige qui tombe derrière les vitres (tempête quand il y a un rabais) ;
   - au clic : zoom sur le chandail + fiche (prix, couleurs, bouton) + le chandail en 3D qui flotte ;
   - les flèches changent de collection (02 : « bientôt ») et préviennent la section produits ;
   - quelques easter eggs (skis, feu, code secret).
   Les coordonnées sont celles de la photo : 1536 × 1024. */
(function () {
  'use strict';

  var BW = 1536, BH = 1024, EXT = 448, SHOWH = 940;   // SHOWH : hauteur de photo à montrer au minimum (plafond -> tapis)
  // patères (centre) : 1-2 à gauche (haut, bas), 3-4 en haut à droite, 5-6 en bas à droite ; aucun chandail ne se chevauche
  var PEGS = [[555, 134], [555, 324], [990, 134], [1160, 134], [990, 324], [1160, 324]];
  // rendu d'un chandail : 480 × 560 px pour 0,84 × 0,98 m ; point d'accroche dans l'image
  var TW = 176, TH = 205, AX = 0.5, AY = 0.0612;
  var FIRE = { x0: 663, y0: 560, x1: 866, y1: 706, logs: 690, cx: 765, cy: 650 };   // vitre du poêle (la vraie vidéo de feu joue dedans)
  var WINS = [[6, 136, 247, 586], [1291, 139, 1532, 590]];
  var TAU = Math.PI * 2;

  function clamp(v, a, b) { return v < a ? a : v > b ? b : v; }
  function rnd(seed) { var s = seed % 2147483647; if (s <= 0) s += 2147483646; return function () { s = s * 16807 % 2147483647; return (s - 1) / 2147483646; }; }

  var scriptCache = {};
  function loadScripts(urls) {
    return urls.reduce(function (p, u) {
      return p.then(function () {
        if ((/three/.test(u) && window.THREE) || (/tee-mesh/.test(u) && window.SHR_TEE) || (/cloth/.test(u) && window.SHR_CLOTH) || (/hoodie-mesh/.test(u) && window.SHR_HOODIE_CLOTH) || (/earth/.test(u) && window.SHR_EARTH)) return;
        if (!scriptCache[u]) scriptCache[u] = new Promise(function (res, rej) {
          var sc = document.createElement('script'); sc.src = u; sc.async = false;
          sc.onload = function () { res(); }; sc.onerror = rej;
          document.head.appendChild(sc);
        });
        return scriptCache[u];
      });
    }, Promise.resolve());
  }

  function init(root) {
    if (root._chalet) return;
    root._chalet = true;
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-chalet-data]').textContent); } catch (e) { return; }
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var viewport = root.querySelector('[data-viewport]'), world = root.querySelector('[data-world]'), stage = root.querySelector('[data-stage]');
    var bg = stage.querySelector('.shr-chalet__bg'), stormImg = root.querySelector('[data-storm-img]');
    var fx = root.querySelector('[data-fx]'), g = fx.getContext('2d');
    var teesBox = root.querySelector('[data-tees]');
    var panel = root.querySelector('[data-panel]'), toastEl = root.querySelector('[data-toast]');
    var storm = !!data.storm, stormBoost = 0;
    var W = 0, H = 0, s = 1, pan = false, zoomed = -1, collection = 0;

    function loadStormExt() {
      root.querySelectorAll('[data-storm-src]').forEach(function (im) { if (!im.src) im.src = im.getAttribute('data-storm-src'); });
    }
    if (storm) { stormImg.src = data.images.storm; loadStormExt(); }
    // le message « clique sur un chandail » ne revient pas pour quelqu'un qui a déjà cliqué
    try { if (localStorage.getItem('shrChaletOpened')) root.classList.add('has-opened'); } catch (e) {}

    // ---------- chandails au mur ----------
    var tees = (data.tees || []).slice(0, 6).map(function (t, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'shr-chalet__tee';
      var p = PEGS[i];
      var k_ = t.kind === 'hoodie' ? 1.2 : 1;                 // le hoodie (rendu plus large : manches longues)
      b.style.left = (p[0] - AX * TW * k_) + 'px'; b.style.top = (p[1] - AY * TH * k_) + 'px';
      b.style.width = (TW * k_) + 'px'; b.style.height = (TH * k_) + 'px';
      b.style.setProperty('--d', (-i * 1.3) + 's');
      b.setAttribute('aria-label', t.title + (t.price ? ' – ' + t.price : ''));
      var img = document.createElement('img'); img.alt = ''; img.decoding = 'async'; img.draggable = false;
      var back = document.createElement('img'); back.alt = ''; back.decoding = 'async'; back.draggable = false; back.className = 'is-hidden';
      b.appendChild(img); b.appendChild(back); teesBox.appendChild(b);
      var tee = { d: t, i: i, el: b, img: img, back: back, color: 0 };
      setWall(tee, 0);
      b.addEventListener('click', function () { open(i); });
      return tee;
    });
    // zip : hoodie seulement, la version zip-up (image wallZip)
    function setWall(tee, k, fade, zip) {
      var c = tee.d.colors[k]; if (!c) return;
      tee.color = k;
      tee.zip = !!(zip && c.wallZip);
      var src = tee.zip ? c.wallZip : c.wall;
      if (fade) {
        // fondu : la nouvelle couleur se charge derrière, puis les deux images échangent leur place
        var front = tee.img, back = tee.back;
        back.onerror = function () { back.onerror = null; back.onload = null; };
        back.onload = function () {
          back.onload = null;
          if (tee.color !== k) return;
          back.classList.remove('is-hidden'); front.classList.add('is-hidden');
          tee.img = back; tee.back = front;
        };
        back.src = src;
      } else {
        tee.back.onload = null;
        tee.back.classList.add('is-hidden'); tee.img.classList.remove('is-hidden');
        tee.img.onerror = function () { tee.img.onerror = null; tee.img.src = c.front; tee.img.style.objectFit = 'contain'; };
        tee.img.src = src;
      }
      // on précharge la couleur suivante
      var nx = tee.d.colors[k + 1]; if (nx) { var im = new Image(); im.src = (c.wallZip && !tee.zip && nx.wallZip) ? nx.wallZip : nx.wall; }
    }

    // ---------- cadrage : la photo couvre la section ; sur téléphone on glisse de gauche à droite ----------
    var firstPan = true;
    function layout() {
      W = root.clientWidth; H = root.clientHeight;
      if (!W || !H) return;
      pan = W / H < 1.05;
      root.classList.toggle('is-pan', pan);
      var offX = 0, offY = 0, ext = 0;
      if (pan) {
        s = H / BH;
      } else {
        // le mur est prolongé de EXT px de chaque côté : sur un écran large on montre toute la hauteur
        // (plafond et haut des fenêtres) au lieu d'agrandir la photo et d'en couper le haut
        ext = EXT;
        s = Math.max(W / (BW + 2 * EXT), H / BH, Math.min(H / SHOWH, W / BW));
        offX = (W - (BW + 2 * EXT) * s) * 0.5; offY = (H - BH * s) * 0.1;
      }
      world.style.width = ((BW + 2 * ext) * s) + 'px'; world.style.height = (BH * s) + 'px';
      world.style.left = offX + 'px'; world.style.top = offY + 'px';
      stage.style.left = (ext * s) + 'px';
      stage.style.transform = 'scale(' + s + ')';
      if (pan && firstPan) { viewport.scrollLeft = (BW * s - W) / 2; firstPan = false; }
      if (zoomed >= 0) zoomTo(zoomed, true);
    }
    window.addEventListener('resize', function () { layout(); });
    layout();

    // ---------- zoom + fiche ----------
    var nameEl = panel.querySelector('[data-p-name]'), priceEl = panel.querySelector('[data-p-price]'), cmpEl = panel.querySelector('[data-p-compare]');
    var noteEl = panel.querySelector('[data-p-note]'), swEl = panel.querySelector('[data-p-swatches]'), cnameEl = panel.querySelector('[data-p-cname]');
    var linkEl = panel.querySelector('[data-p-link]'), modelEl = panel.querySelector('[data-model]');
    function zoomTo(i, instant) {
      var tee = tees[i]; if (!tee) return;
      // on mesure le mur SANS zoom (et sans animation en cours), sinon on vise à côté quand on passe
      // d'un chandail à l'autre alors qu'on est déjà zoomé
      var prevT = world.style.transform;
      world.style.transition = 'none';
      world.style.transform = 'none';
      var vr = viewport.getBoundingClientRect(), wr = world.getBoundingClientRect(), r = tee.el.getBoundingClientRect();
      var cx = r.left + r.width / 2 - vr.left, cy = r.top + r.height * 0.45 - vr.top;
      var wx = wr.left - vr.left, wy = wr.top - vr.top;
      var mobile = W < 720;
      var panelW = mobile ? 0 : Math.min(400, W * 0.36) + Math.max(20, W * 0.04);
      var Tx = mobile ? W / 2 : (W - panelW) / 2, Ty = mobile ? H * 0.2 : H * 0.5;
      var Z = clamp((mobile ? 0.34 : 0.6) * H / r.height, 1.25, 2.3);
      var tx = Tx - wx - (cx - wx) * Z, ty = Ty - wy - (cy - wy) * Z;
      // jamais de bord vide : la photo agrandie couvre toujours la section
      var ww = wr.width * Z, wh = wr.height * Z;
      if (!pan) tx = clamp(tx, W - wx - ww, -wx);
      ty = clamp(ty, H - wy - wh, -wy);
      // on repart de là où on était, puis on glisse vers le nouveau chandail
      world.style.transform = prevT;
      void world.offsetWidth;
      world.style.transition = instant ? 'none' : '';
      world.style.transform = 'translate(' + tx + 'px,' + ty + 'px) scale(' + Z + ')';
      if (instant) { void world.offsetWidth; world.style.transition = ''; }
    }
    function fillPanel(tee) {
      var d = tee.d;
      nameEl.textContent = d.title;
      priceEl.textContent = d.price || '';
      cmpEl.textContent = d.compare || '';
      noteEl.textContent = d.note || '';
      swEl.innerHTML = '';
      d.colors.forEach(function (c, k) {
        var sb = document.createElement('button');
        sb.type = 'button'; sb.className = 'shr-chalet__swatch';
        sb.style.setProperty('--sw', c.hex);
        sb.setAttribute('aria-label', c.name);
        sb.setAttribute('aria-pressed', k === tee.color ? 'true' : 'false');
        sb.addEventListener('click', function () { pickColor(tee, k); });
        swEl.appendChild(sb);
      });
      var c0 = d.colors[tee.color] || {};
      cnameEl.textContent = c0.name || '';
      linkEl.href = c0.url || d.url || '#';
    }
    // ---------- les chandails du mur changent de couleur toutes les 2 à 4 s (pas tous en même temps) ----------
    function cycleRest(min) {
      var now = performance.now();
      tees.forEach(function (t, q) { t.next = now + (min || 2000) + q * 400 + Math.random() * 2000; });
    }
    cycleRest(1500);
    if (!reduce) setInterval(function () {
      if (zoomed >= 0 || document.hidden || !visible || collection !== 0) return;
      var now = performance.now();
      tees.forEach(function (t) {
        if (now < t.next || t.d.colors.length < 2) return;
        // couleur suivante, en sautant celles déjà sur le mur (sinon on se retrouve avec 4 chandails pareils)
        var n = t.d.colors.length, k = (t.color + 1) % n, shown = tees.filter(function (o) { return o !== t; }).map(function (o) { return o.d.colors[o.color].name; });
        for (var tries = 0; tries < n && shown.indexOf(t.d.colors[k].name) >= 0; tries++) k = (k + 1) % n;
        // hoodie : on alterne aussi entre le hoodie normal et le zip-up à chaque changement
        setWall(t, k, true, t.d.colors[k].wallZip ? !t.zip : false);
        t.next = now + 2000 + Math.random() * 2000;          // toutes les 2 à 4 s
      });
    }, 400);
    // ---------- case « Zip-up » (hoodie) ----------
    var zipEl = panel.querySelector('[data-zip]'), zipIn = panel.querySelector('[data-zip-input]'), zipOn = false;
    function syncZip(tee) {
      var alt = tee.d.alt, c = tee.d.colors[tee.color] || {};
      if (zipEl) zipEl.hidden = !alt;
      if (!alt) { zipOn = false; return; }
      var lbl = zipEl.querySelector('[data-zip-label]'); if (lbl) lbl.textContent = (alt.label || 'Zip-up') + (alt.price ? ' – ' + alt.price : '');
      zipIn.checked = zipOn;
      priceEl.textContent = zipOn ? (alt.price || tee.d.price || '') : (tee.d.price || '');
      linkEl.href = (zipOn && c.zipUrl) ? c.zipUrl : (c.url || tee.d.url || '#');
    }
    if (zipIn) zipIn.addEventListener('change', function () {
      zipOn = zipIn.checked;
      var tee = tees[zoomed]; if (!tee) return;
      syncZip(tee);
      setWall(tee, tee.color, false, zipOn);
      if (hoodieV && tee.d.kind === 'hoodie') hoodieV.show(tee.d, tee.color, zipOn);
    });
    function pickColor(tee, k) {
      setWall(tee, k, false, zipOn);
      [].forEach.call(swEl.children, function (b, q) { b.setAttribute('aria-pressed', q === k ? 'true' : 'false'); });
      var c = tee.d.colors[k];
      cnameEl.textContent = c.name; linkEl.href = c.url || tee.d.url;
      syncZip(tee);
      if (tee.d.kind === 'hoodie') { if (hoodieV) hoodieV.show(tee.d, k, zipOn); else showPhoto(tee, k); }
      else if (tee.d.flat) showPhoto(tee, k); else if (viewer) viewer.show(tee.d, k);
    }
    // fiche « photo » (hoodie…) : l'image du dos à la place du chandail 3D
    var photoEl = document.createElement('img');
    photoEl.className = 'shr-chalet__photo'; photoEl.alt = ''; photoEl.decoding = 'async'; photoEl.hidden = true;
    modelEl.appendChild(photoEl);
    function showPhoto(tee, k) {
      var c = tee.d.colors[k] || tee.d.colors[0];
      photoEl.src = (tee.d.kind === 'hoodie' && c.back) ? c.back : c.front; photoEl.hidden = false;
      modelEl.classList.add('is-photo');
    }
    function open(i) {
      if (zoomed === i) return;
      zoomed = i;
      root.classList.add('has-opened');
      try { localStorage.setItem('shrChaletOpened', '1'); } catch (e) {}
      tees.forEach(function (t) { t.el.classList.toggle('is-active', t.i === i); });
      root.classList.add('is-zoomed');
      zoomTo(i);
      fillPanel(tees[i]);
      panel.hidden = false;
      requestAnimationFrame(function () { panel.classList.add('is-open'); });
      zipOn = !!(tees[i].zip && tees[i].d.alt); syncZip(tees[i]);
      if (tees[i].d.kind === 'hoodie') {
        if (viewer) viewer.pause();
        modelEl.classList.add('is-hoodie');
        if (!hoodieV) showPhoto(tees[i], tees[i].color);          // la photo en attendant le 3D
        ensureHoodie().then(function (v) {
          if (!v || zoomed !== i) return;
          photoEl.hidden = true; modelEl.classList.remove('is-photo');
          v.show(tees[i].d, tees[i].color, zipOn);
        });
        return;
      }
      modelEl.classList.remove('is-hoodie');
      if (hoodieV) hoodieV.pause();
      if (tees[i].d.flat) { if (viewer) viewer.pause(); showPhoto(tees[i], tees[i].color); return; }
      photoEl.hidden = true; modelEl.classList.remove('is-photo');
      ensureViewer().then(function (v) { if (v && zoomed === i) v.show(tees[i].d, tees[i].color); });
    }
    function close() {
      if (zoomed < 0) return;
      zoomed = -1;
      root.classList.remove('is-zoomed');
      tees.forEach(function (t) { t.el.classList.remove('is-active'); });
      world.style.transform = 'none';
      cycleRest(1500);
      panel.classList.remove('is-open');
      if (viewer) viewer.pause();
      if (hoodieV) hoodieV.pause();
      setTimeout(function () { if (zoomed < 0) panel.hidden = true; }, 500);
    }
    panel.querySelector('[data-close]').addEventListener('click', close);
    viewport.addEventListener('click', function (e) { if (zoomed >= 0 && !e.target.closest('.shr-chalet__tee')) close(); });
    root.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

    // ---------- le chandail en 3D dans la fiche (même tissu que l'ancien télésiège) ----------
    var viewer = null, viewerP = null;
    function ensureViewer() {
      if (viewerP) return viewerP;
      viewerP = loadScripts(data.scripts || []).then(function () {
        if (!window.THREE || !window.SHR_TEE || !window.SHR_CLOTH) return null;
        try { viewer = makeViewer(window.THREE, modelEl, data.images.logo, reduce); } catch (e) { if (window.console) console.warn('SHREDDERS 3D', e); viewer = null; }
        return viewer;
      }).catch(function () { return null; });
      return viewerP;
    }

    var hoodieV = null, hoodieP = null;
    function ensureHoodie() {
      if (hoodieP) return hoodieP;
      hoodieP = loadScripts(data.scriptsHoodie || []).then(function () {
        if (!window.THREE || !window.SHR_HOODIE_CLOTH || !window.SHR_CLOTH) return null;
        try { hoodieV = makeViewer(window.THREE, modelEl, null, reduce, { mesh: window.SHR_HOODIE_CLOTH, hoodie: true }); } catch (e) { if (window.console) console.warn('SHREDDERS hoodie 3D', e); hoodieV = null; }
        return hoodieV;
      }).catch(function () { return null; });
      return hoodieP;
    }

    // ---------- feu, lueur, neige derrière les vitres ----------
    var winCv = WINS.map(function (w) { var c = document.createElement('canvas'); c.width = w[2] - w[0]; c.height = w[3] - w[1]; return c; });
    var mask = new Image(); var maskOk = false;
    mask.onload = function () { maskOk = true; }; mask.src = data.images.glass;
    var R = rnd(17), flakes = [];
    function makeFlakes() {
      flakes = [];
      var n = storm ? 520 : 150;
      for (var k = 0; k < n; k++) flakes.push({ w: k % 2, x: R(), y: R(), z: Math.pow(R(), 1.5), ph: R() * TAU, sp: 0.6 + R() * 0.8 });
    }
    makeFlakes();
    var embers = [];
    var last = 0, visible = true, raf = 0, t0 = performance.now(), sparkUntil = 0;
    function drawSnow(t, dt) {
      var heavy = storm || stormBoost > 0;
      for (var w = 0; w < 2; w++) {
        var c = winCv[w], cg = c.getContext('2d'), WW = c.width, HH = c.height;
        cg.globalCompositeOperation = 'source-over';
        cg.clearRect(0, 0, WW, HH);
        var wind = heavy ? -0.9 : -0.12, fall = heavy ? 2.6 : 0.55;
        for (var k = 0; k < flakes.length; k++) {
          var f = flakes[k]; if (f.w !== w) continue;
          var sz = 0.8 + f.z * (heavy ? 3.2 : 3.6);
          f.y += dt * fall * (0.25 + f.z * 0.75) * f.sp * 0.25;
          f.x += dt * (wind * (0.3 + f.z) * 0.25 + Math.sin(t * 0.9 * f.sp + f.ph) * (heavy ? 0.02 : 0.012));
          if (f.y > 1.05) { f.y = -0.05; f.x = R(); }
          if (f.x < -0.05) f.x += 1.1; else if (f.x > 1.05) f.x -= 1.1;
          var x = f.x * WW, y = f.y * HH;
          cg.globalAlpha = 0.45 + f.z * 0.5;
          cg.fillStyle = '#fff';
          if (heavy && f.z > 0.25) {
            // en tempête : traits obliques (flou de bougé)
            cg.strokeStyle = 'rgba(255,255,255,' + (0.35 + f.z * 0.5).toFixed(2) + ')';
            cg.lineWidth = sz * 0.55;
            cg.beginPath(); cg.moveTo(x, y); cg.lineTo(x - wind * 16 * f.z, y - 10 * f.z - 4); cg.stroke();
          } else {
            cg.beginPath(); cg.arc(x, y, sz * 0.5, 0, TAU); cg.fill();
          }
        }
        cg.globalAlpha = 1;
        if (heavy) {
          // rafales : voile blanc qui passe
          var gust = 0.12 + 0.12 * Math.max(0, Math.sin(t * 0.7 + w * 1.3)) + 0.08 * Math.max(0, Math.sin(t * 2.3));
          cg.fillStyle = 'rgba(240,244,250,' + gust.toFixed(3) + ')';
          cg.fillRect(0, 0, WW, HH);
        }
        if (maskOk) {
          cg.globalCompositeOperation = 'destination-in';
          var wr = WINS[w];
          cg.drawImage(mask, wr[0], wr[1], WW, HH, 0, 0, WW, HH);
        }
        g.drawImage(c, WINS[w][0], WINS[w][1]);
      }
    }
    // intensité du feu, lue dans la vidéo (lueur sur le plancher qui suit les vraies flammes)
    var vid = root.querySelector('[data-fire-video]'), probe = document.createElement('canvas'), pg = null, fireLvl = 0.5;
    probe.width = probe.height = 6;
    try { pg = probe.getContext('2d', { willReadFrequently: true }); } catch (e) { pg = null; }
    function fireLevel() {
      if (fireImg) { var tt = performance.now() / 1000; return 0.55 + 0.12 * Math.sin(tt * 7.3) + 0.08 * Math.sin(tt * 12.9 + 1.7); }
      if (!vid || !pg || vid.readyState < 2) return 0.5;
      try {
        pg.drawImage(vid, 0, 0, 6, 6);
        var px = pg.getImageData(0, 0, 6, 6).data, sum = 0;
        for (var q = 0; q < px.length; q += 4) sum += px[q] * 0.5 + px[q + 1] * 0.4 + px[q + 2] * 0.1;
        return clamp(sum / 36 / 110, 0, 1.4);
      } catch (e) { pg = null; return 0.5; }
    }
    function drawFire(t, dt) {
      fireLvl += (fireLevel() - fireLvl) * Math.min(1, dt * 8);
      var fl = fireLvl;
      g.globalCompositeOperation = 'lighter';
      // reflet chaud sur le cadre de fonte autour de la vitre
      var gr = g.createRadialGradient(FIRE.cx, FIRE.cy, 40, FIRE.cx, FIRE.cy, 150);
      gr.addColorStop(0, 'rgba(255,140,50,0)'); gr.addColorStop(0.6, 'rgba(255,130,40,' + (0.05 * fl).toFixed(3) + ')'); gr.addColorStop(1, 'rgba(255,120,30,0)');
      g.fillStyle = gr; g.fillRect(FIRE.x0 - 90, FIRE.y0 - 70, FIRE.x1 - FIRE.x0 + 180, FIRE.y1 - FIRE.y0 + 160);
      // lueur sur la dalle, le tapis et le plancher
      var fg = g.createRadialGradient(770, 860, 0, 770, 860, 520);
      fg.addColorStop(0, 'rgba(255,140,50,' + (0.03 + 0.08 * fl).toFixed(3) + ')'); fg.addColorStop(1, 'rgba(255,120,40,0)');
      g.save(); g.translate(770, 860); g.scale(1, 0.38); g.translate(-770, -860);
      g.fillStyle = fg; g.fillRect(250, 340, 1040, 1040); g.restore();
      g.globalCompositeOperation = 'source-over';
      // reflet du jour sur la vitre (fenêtre de gauche) : une bande diagonale très douce
      var sh = g.createLinearGradient(FIRE.x0, FIRE.y0, FIRE.x0 + 120, FIRE.y1);
      sh.addColorStop(0, 'rgba(255,255,255,0.07)'); sh.addColorStop(0.35, 'rgba(255,255,255,0.025)'); sh.addColorStop(0.36, 'rgba(255,255,255,0)'); sh.addColorStop(1, 'rgba(255,255,255,0)');
      g.fillStyle = sh; g.fillRect(FIRE.x0 + 3, FIRE.y0 + 10, FIRE.x1 - FIRE.x0 - 6, FIRE.y1 - FIRE.y0 - 12);
      g.globalCompositeOperation = 'lighter';
      // étincelles (surtout quand on clique sur le feu)
      var rate = (t < sparkUntil ? 60 : 1.5) * dt;
      while (rate > 0) { if (Math.random() < rate) embers.push({ x: FIRE.x0 + 30 + Math.random() * (FIRE.x1 - FIRE.x0 - 60), y: FIRE.logs - 10, vx: (Math.random() - 0.5) * 14, vy: -(20 + Math.random() * 40), life: 1 }); rate -= 1; }
      for (var e = embers.length - 1; e >= 0; e--) {
        var em = embers[e];
        em.life -= dt * 0.7; em.x += em.vx * dt; em.y += em.vy * dt; em.vx += Math.sin(t * 7 + e) * 8 * dt;
        if (em.life <= 0 || em.y < FIRE.y0 + 4) { embers.splice(e, 1); continue; }
        g.fillStyle = 'rgba(255,' + Math.round(150 + 80 * em.life) + ',60,' + (em.life * 0.9).toFixed(2) + ')';
        g.fillRect(em.x, em.y, 1.6, 1.6);
      }
      g.globalCompositeOperation = 'source-over';
    }
    function frame(now) {
      raf = 0;
      if (!visible || collection !== 0) return;
      var dt = last ? Math.min(0.05, (now - last) / 1000) : 1 / 30;
      if (now - last < 31) { raf = requestAnimationFrame(frame); return; }     // ~30 images/s suffisent
      last = now;
      var t = (now - t0) / 1000;
      if (stormBoost > 0) { stormBoost -= dt; if (stormBoost <= 0) setStorm(!!data.storm); }
      g.clearRect(0, 0, BW, BH);
      drawFire(t, dt);
      drawSnow(t, dt);
      raf = requestAnimationFrame(frame);
    }
    function kick() { if (!raf && !reduce) raf = requestAnimationFrame(frame); syncVideo(); }
    // Safari (mode économie d'énergie) et certains téléphones bloquent la lecture automatique des vidéos :
    // le feu attendait un clic. Dans ce cas, on le remplace par une image animée, qui joue toujours.
    var fireImg = null;
    function useFireAnim() {
      if (fireImg || !vid || !data.images.fireAnim) return;
      fireImg = document.createElement('img');
      fireImg.className = vid.className;
      fireImg.setAttribute('style', vid.getAttribute('style') || '');
      fireImg.alt = ''; fireImg.setAttribute('aria-hidden', 'true'); fireImg.draggable = false;
      fireImg.decoding = 'async';
      fireImg.src = data.images.fireAnim;
      vid.parentNode.insertBefore(fireImg, vid.nextSibling);
      vid.pause(); vid.style.visibility = 'hidden';
    }
    function syncVideo() {
      if (!vid || fireImg) return;
      var play = visible && collection === 0 && !reduce;
      if (play && vid.paused) {
        var pr = vid.play();
        if (pr && pr.catch) pr.catch(function (err) { if (err && err.name === 'NotAllowedError') useFireAnim(); });
      }
      else if (!play && !vid.paused) vid.pause();
    }
    if (vid) {
      vid.muted = true;
      if (reduce) { vid.removeAttribute('autoplay'); vid.pause(); }
      // pas de réponse de la vidéo après 2,5 s (lecture bloquée sans erreur) : image animée
      if (!reduce) setTimeout(function () { if (vid.paused && visible && collection === 0) useFireAnim(); }, 2500);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; if (visible) kick(); else syncVideo(); }).observe(root);
    }
    document.addEventListener('visibilitychange', function () { visible = !document.hidden; if (visible) kick(); else syncVideo(); });
    if (reduce) { bg.complete ? drawStatic() : bg.addEventListener('load', drawStatic); }
    function drawStatic() { g.clearRect(0, 0, BW, BH); drawSnow(0, 0); }
    kick();

    function setStorm(on) {
      storm = on;
      root.classList.toggle('is-storm', on);
      if (on && !stormImg.src) stormImg.src = data.images.storm;
      if (on) loadStormExt();
      makeFlakes();
    }

    // ---------- collections ----------
    var scenes = root.querySelectorAll('[data-scene]');
    var globe = makeEarth(root.querySelector('[data-globe]'), root.querySelector('[data-earth-pins]'), data.earth || {}, reduce);
    function setCollection(k, fromHash) {
      k = (k + scenes.length) % scenes.length;
      if (k === collection) return;
      close();
      collection = k;
      [].forEach.call(scenes, function (sc, q) { sc.hidden = q !== k; });
      if (k === 1) { globe.start(); syncVideo(); } else { globe.stop(); kick(); }
      // toute la page change de couleurs (comme un autre site) quand on est sur les Continents
      var html = document.documentElement;
      if (!fromHash) html.classList.add('shr-palette-anim');
      html.classList.toggle('shr-continents', k === 1);
      document.dispatchEvent(new CustomEvent('shr:collection', { detail: { index: k } }));
      if (!fromHash) {
        try { history.replaceState(null, '', k === 1 ? '#continents' : location.pathname + location.search); } catch (e) {}
      }
    }
    [].forEach.call(root.querySelectorAll('[data-coll]'), function (b) {
      b.addEventListener('click', function () { setCollection(collection + parseInt(b.getAttribute('data-coll'), 10)); });
    });
    if (location.hash === '#continents') setCollection(1, true);

    // ---------- easter eggs ----------
    var toastT = 0;
    function toast(msg) {
      if (!msg) return;
      toastEl.textContent = msg; toastEl.classList.add('is-on');
      clearTimeout(toastT); toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 4200);
    }
    root.querySelector('[data-egg="skis"]').addEventListener('click', function (e) { e.stopPropagation(); toast(data.eggs && data.eggs.skis); });
    root.querySelector('[data-egg="fire"]').addEventListener('click', function (e) {
      e.stopPropagation(); sparkUntil = (performance.now() - t0) / 1000 + 1.2; toast(data.eggs && data.eggs.fire); kick();
    });
    var KONAMI = ['ArrowUp', 'ArrowUp', 'ArrowDown', 'ArrowDown', 'ArrowLeft', 'ArrowRight', 'ArrowLeft', 'ArrowRight', 'b', 'a'], kpos = 0;
    document.addEventListener('keydown', function (e) {
      var key = e.key.length === 1 ? e.key.toLowerCase() : e.key;
      kpos = key === KONAMI[kpos] ? kpos + 1 : (key === KONAMI[0] ? 1 : 0);
      if (kpos === KONAMI.length) { kpos = 0; stormBoost = 14; setStorm(true); toast(data.eggs && data.eggs.konami); kick(); }
    });

    root._chaletApi = { open: open, close: close, setCollection: setCollection, setStorm: setStorm, layout: layout };
  }

  // =====================================================================
  // le chandail en 3D (fiche) : tissu simulé, qui flotte et tourne doucement ; on peut le faire pivoter
  // opt.hoodie : même tissu, même cintre, mais le hoodie (capuche relevée, devant et dos imprimés)
  function makeViewer(THREE, host, logoUrl, reduce, opt) {
    opt = opt || {};
    var HOOD = !!opt.hoodie;
    var TEE = opt.mesh || window.SHR_TEE, CL = window.SHR_CLOTH;
    var r = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    r.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    r.outputColorSpace = THREE.SRGBColorSpace;
    r.domElement.className = HOOD ? 'shr-chalet__hoodie3d' : 'shr-chalet__tee3d';
    host.appendChild(r.domElement);
    var scene = new THREE.Scene(), cam = new THREE.PerspectiveCamera(28, 1, 0.05, 20);
    if (HOOD) {
      // tout le hoodie (crochet, capuche et ourlet) dans le cadre
      var cyH = ((TEE.top || 0.3) + 0.05 + (TEE.bottom || -0.79)) / 2;
      cam.position.set(0, cyH + 0.01, 2.62); cam.lookAt(0, cyH - 0.01, 0);
    } else {
      cam.position.set(0, -0.36, 2.15); cam.lookAt(0, -0.38, 0);
    }
    scene.add(new THREE.HemisphereLight(0xfff4e6, 0xc9b49a, 2.2));
    var key = new THREE.DirectionalLight(0xfff0dc, 1.6); key.position.set(-1.5, 1.2, 2); scene.add(key);
    var rim = new THREE.DirectionalLight(0xffb070, 0.8); rim.position.set(1.4, -0.6, -1); scene.add(rim);
    var blank = (function () { var c = document.createElement('canvas'); c.width = c.height = 4; var t = new THREE.CanvasTexture(c); t.colorSpace = THREE.SRGBColorSpace; return t; })();
    var logoTex = new THREE.Texture(); logoTex.colorSpace = THREE.SRGBColorSpace;
    var geo = CL.geometry(THREE, TEE), mat = CL.material(THREE, { blank: blank, logo: logoTex });
    var u = mat.userData.u;
    if (HOOD) { u.uAlbedo.value = 1; u.uLogoOn.value = 0; if (mat.normalScale) mat.normalScale.set(0.22, 0.22); mat.sheen = 0.35; }
    var img = new Image(); img.crossOrigin = 'anonymous';
    img.onload = function () {
      var c = document.createElement('canvas'); c.width = 1024; c.height = Math.round(1024 * img.height / img.width) + 16;
      var gg = c.getContext('2d');
      for (var k = 0; k < 12; k++) gg.drawImage(img, 8 + Math.cos(k / 12 * Math.PI * 2) * 3.2, 8 + Math.sin(k / 12 * Math.PI * 2) * 3.2, 1008, c.height - 16);
      logoTex.image = c; logoTex.needsUpdate = true; u.uLogoOn.value = 1;
    };
    if (logoUrl) img.src = logoUrl;
    var mesh = new THREE.Mesh(geo, mat); mesh.frustumCulled = false;
    var pivot = new THREE.Group(); pivot.add(mesh); scene.add(pivot);
    // cintre en bois visible par le col
    var chromeM = new THREE.MeshStandardMaterial({ color: 0xd8dde3, metalness: 0.9, roughness: 0.25 });
    var hook = new THREE.Mesh(new THREE.TorusGeometry(0.035, 0.0035, 8, 24, Math.PI * 1.3), chromeM);
    hook.position.set(0, 0.075, 0); hook.rotation.z = -Math.PI * 0.15; pivot.add(hook);
    if (HOOD) {
      // hoodie : la tige du crochet monte derrière la capuche et ressort au-dessus
      var top = TEE.top || 0.295;
      hook.position.set(0, top + 0.045, -0.035);
      var rod = new THREE.Mesh(new THREE.CylinderGeometry(0.0035, 0.0035, top + 0.02, 8), chromeM);
      rod.position.set(-0.033 * Math.cos(Math.PI * 0.15), (top + 0.02) / 2 + 0.01, -0.035); pivot.add(rod);
      hook.position.x = 0;
    }
    var cloth = new CL.Cloth(TEE);
    var ident = new Float64Array([1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1]);
    // à l'intérieur du chalet : juste un léger courant d'air (pas de grosses rafales)
    var P = { substeps: 4, damping: 0.9, bend: 0.0001, memory: 8, wind: { t: 0, x: -0.3, y: 0, z: 0.25, turb: 0.3, drag: 0.08 } };
    // hoodie : le molleton garde sa forme (on n'a pas de drapé précalculé) -> peu de gravité, forte mémoire
    if (HOOD) { P.memory = 30; P.gravity = -0.6; P.damping = 1.6; }
    var pos = geo.attributes.position, nrm = geo.attributes.normal;
    var loader = new THREE.TextureLoader(); loader.setCrossOrigin('anonymous');
    var running = false, raf = 0, last = 0, t = 0, yaw = 0, drag = null, userYaw = 0;
    // le client fait tourner le chandail comme il veut ; après 10 s sans y toucher, il revient de face
    var HOLD = 10000, lastUser = -1e9, swayW = 1, spin = 0;
    function size() {
      var w = host.clientWidth || 300, h = host.clientHeight || 240;
      r.setSize(w, h, false); cam.aspect = w / h; cam.updateProjectionMatrix();
    }
    function frame(now) {
      raf = 0; if (!running) return;
      var dt = last ? Math.min(0.05, (now - last) / 1000) : 1 / 60; last = now; t += dt;
      if (!reduce) {
        var gust = 0.7 + 0.3 * Math.sin(t * 0.6);
        P.wind.x = -0.3 * gust; P.wind.z = 0.25 * gust;
        cloth.advance(dt, ident, P); cloth.write(pos.array, nrm.array);
        pos.needsUpdate = nrm.needsUpdate = true;
      }
      var nowT = performance.now();
      if (!drag && Math.abs(spin) > 0.01 && nowT - lastUser < HOLD) {      // petit élan quand on lâche
        userYaw += spin * dt; spin *= Math.pow(0.05, dt);
      }
      if (!drag && nowT - lastUser > HOLD) {
        var front = Math.round(userYaw / (Math.PI * 2)) * Math.PI * 2;      // le devant le plus proche
        userYaw += (front - userYaw) * (1 - Math.pow(0.12, dt));
        if (Math.abs(front - userYaw) < 0.002) userYaw = 0;
        swayW = Math.min(1, swayW + dt * 0.4);
      }
      yaw = userYaw + (reduce ? 0 : swayW * Math.sin(t * 0.45) * 0.55);
      pivot.rotation.y = yaw; host._yaw = yaw;
      pivot.position.y = reduce ? 0 : Math.sin(t * 1.1) * 0.012;       // il flotte
      r.render(scene, cam);
      raf = requestAnimationFrame(frame);
    }
    host.addEventListener('pointerdown', function (e) {
      if (!running) return;
      userYaw = yaw; swayW = 0; spin = 0;                                  // on part de l'angle affiché, sans saut
      drag = { x: e.clientX, y0: userYaw, px: e.clientX, pt: performance.now() };
      lastUser = performance.now();
      try { host.setPointerCapture(e.pointerId); } catch (er) {}
    });
    host.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var n = performance.now();
      userYaw = drag.y0 + (e.clientX - drag.x) * 0.012;
      if (n > drag.pt) spin = (e.clientX - drag.px) * 0.012 / ((n - drag.pt) / 1000);
      drag.px = e.clientX; drag.pt = n; lastUser = n;
    });
    host.addEventListener('pointerup', function () {
      if (drag && performance.now() - drag.pt > 80) spin = 0;              // lâché sans bouger : pas d'élan
      drag = null; lastUser = performance.now(); spin = Math.max(-12, Math.min(12, spin));
    });
    host.addEventListener('pointercancel', function () { drag = null; });
    window.addEventListener('resize', size);
    return {
      show: function (d, k, zip) {
        var c = d.colors[k] || d.colors[0];
        var col = new THREE.Color(c.hex);
        if (HOOD) {
          u.uFab.value.copy(col);
          mat.sheenColor && mat.sheenColor.copy(col).lerp(new THREE.Color(1, 1, 1), 0.3);
          var fu = zip && c.zip ? c.zip : (c.front3d || c.front), bu = c.back || fu;
          loader.load(fu, function (tx) { tx.colorSpace = THREE.SRGBColorSpace; tx.anisotropy = r.capabilities.getMaxAnisotropy(); u.uMapA.value = tx; });
          loader.load(bu, function (tx) { tx.colorSpace = THREE.SRGBColorSpace; tx.anisotropy = r.capabilities.getMaxAnisotropy(); u.uMapBk.value = tx; });
          if (c.zip && !zip) { var pre = new Image(); pre.src = c.zip; }
          size(); running = true; last = 0; if (!raf) raf = requestAnimationFrame(frame);
          return;
        }
        u.uFab.value.copy(col); u.uFabA.value.copy(col); u.uFabB.value.copy(col);
        if (u.uLogoInk) { if (c.ink === 'white') u.uLogoInk.value.setRGB(0.8, 0.8, 0.8); else u.uLogoInk.value.setRGB(0.035, 0.035, 0.04); }
        mat.sheenColor && mat.sheenColor.copy(col).lerp(new THREE.Color(1, 1, 1), 0.45);
        loader.load(c.front, function (tx) {
          tx.colorSpace = THREE.SRGBColorSpace; tx.anisotropy = r.capabilities.getMaxAnisotropy();
          u.uMapA.value = u.uMapB.value = tx; u.uMix.value = 0;
        });
        size(); running = true; last = 0; if (!raf) raf = requestAnimationFrame(frame);
      },
      pause: function () { running = false; }
    };
  }



  // =====================================================================
  // collection 02 : un globe en fil de fer qui tourne lentement (méridiens + parallèles + points)
  // la Terre (Collection 02) : chargée seulement quand on va sur les Continents
  function makeEarth(cv, pins, E, reduce) {
    if (!cv || !pins) return { start: function () {}, stop: function () {} };
    var earth = null, want = false, loading = null;
    function go() {
      if (earth) { if (want) earth.start(); return; }
      if (loading) return;
      loading = loadScripts(E.scripts || []).then(function () {
        if (!window.THREE || !window.SHR_EARTH) return;
        try { earth = window.SHR_EARTH.create(window.THREE, cv, pins, { day: E.day, night: E.night, relief: E.relief, peaks: E.peaks, reduce: reduce }); }
        catch (e) { if (window.console) console.warn('SHREDDERS Terre', e); return; }
        if (want) earth.start();
      }).catch(function () {});
    }
    return {
      start: function () { want = true; go(); },
      stop: function () { want = false; if (earth) earth.stop(); }
    };
  }

  function boot(scope) { [].forEach.call((scope || document).querySelectorAll('[data-shr-chalet]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
